import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

// import components
import SideNavMenu from '../elements/NavVerticalGroup';
import RecentUpdates from './DataProcessing.SupportContents.CurrentUpdates';
import DemoSession from './DataProcessing.SupportContents.Demo';


class SupportContents extends React.Component {
  constructor(props){
    super(props);
    this.state={
      activeTab: 'demo-session'
    }
  }

  updateActiveTab = (activeTab) => {
    this.setState({activeTab});
  }

  render() {
  // console.log(this.state);
  return (
    <div css={css`
      width: 100%;
      margin: 50px 0;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
    `}>
      <div css={css`
        width: 20%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-start;
      `}>
        <SideNavMenu 
          activeTab={this.state.activeTab}
          menu={this.props.menu}
          updateActiveTab={this.updateActiveTab}
        />
      </div>

      <div css={css`
        width: 78%;
      `}>
      {
        this.state.activeTab === 'demo-session'
        &&
        <DemoSession 
          items={this.props.dataProcessingSessionDemonItems}
        />
      }
      {
        this.state.activeTab === 'recent-updates'
        &&
        <RecentUpdates 
          items={this.props.dataProcessingCurrentUpdateItems}
        />
      }
      </div>
    
  </div>
  )
}
}

export default SupportContents;